export default {
  p3: {
    getTheme: () => import('@/router/theme_a'),
    skins: {
      default: 'dark_green',
      dark_green: () => import('@a/skins/dark_green.scss'),
      // xxx: () => import('@b/skins/dark_gold.scss'),
    },
  },

  p4: {
    getTheme: () => import('@/router/theme_b'),
    skins: {
      default: 'dark_gold',
      dark_gold: () => import('@b/skins/dark_gold.scss'),
      light_purple: () => import('@b/skins/light_purple.scss'),
      dark_purple: () => import('@b/skins/dark_purple.scss'),
      black_background_red: () => import('@b/skins/black_background_red.scss'),
      purple_background_red: () =>
        import('@b/skins/purple_background_red.scss'),
      dark_red: () => import('@b/skins/dark_red.scss'),
      blue_purple: () => import('@b/skins/blue_purple.scss'),
      // xxx: () => import('@a/skins/dark_green.scss')
    },
  },

  default: 'p4',
}
